import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// (c) 2023 Acellera Ltd http://www.acellera.com
// All Rights Reserved
// No redistribution in whole or part
//
import { Grid, Divider } from "@mui/material";
export function DefinedNumArgs({ repeatElement, numElements, }) {
    return (_jsxs(Grid, Object.assign({ container: true, direction: "row", alignItems: "flex-end", sx: { my: 1 } }, { children: [numElements > 1 ? (_jsx(Divider, { sx: { mr: 1 }, orientation: "vertical", flexItem: true, variant: "middle" })) : null, _jsx(Grid, Object.assign({ item: true, container: true, direction: "column", xs: true, spacing: 2 }, { children: Array.from(Array(numElements)).map((x, i) => (_jsx(Grid, Object.assign({ item: true }, { children: repeatElement(i) }), `defined-nargs-${i}`))) }))] })));
}
